export class CountryModel {
	public category: string;
	public code: string;
	public values: string;
	public param1: string;
	public param2: boolean;
	public ìcon: boolean;

	public convert(dto: any): CountryModel {

		if (dto.category) {
			this.category = dto.category;
		}
		if (dto.code) {
			this.code = dto.code;
		}
		if (dto.values) {
			this.values = dto.values;
		}
		if (dto.param1) {
			this.param1 = dto.param1;
		}
		if (dto.param2) {
			this.param2 = dto.param2;
		}
		if (dto.ìcon) {
			this.ìcon = dto.ìcon;
		}
		return this;
	}
}
